export function useElementOperations() {
  // 元素对齐
  const setElsAlign = (align: string, printInstance: any) => {
    if (printInstance) {
      printInstance.setElsAlign(align)
    }
  }

  // 设置元素间距
  const setElsSpace = (horizontal: boolean, printInstance: any) => {
    if (printInstance) {
      printInstance.setElsSpace(10, horizontal)
    }
  }

  // 根据field选择元素
  const setEleSelectByField = (printInstance: any) => {
    if (printInstance) {
      printInstance.selectElementsByField(['name'])
    }
  }

  // 获取选中元素
  const getSelectEls = (printInstance: any) => {
    if (printInstance) {
      const els = printInstance.getSelectEls()
      return els
    }
    return []
  }

  // 获取选中表格
  const getSelectTable = (printInstance: any) => {
    if (printInstance) {
      const table = printInstance.getSelectTable()
      return table
    }
    return []
  }

  // 获取所有表格
  const getAllTables = (printInstance: any) => {
    if (printInstance) {
      const tables = printInstance.getAllTables()
      return tables
    }
    return []
  }

  // 更新字体大小
  const updateFontSize = (printInstance: any) => {
    if (printInstance) {
      printInstance.updateOption('fontSize', 12)
    }
  }

  // 更新字体粗细
  const updateFontWeight = (printInstance: any) => {
    if (printInstance) {
      printInstance.updateOption('fontWeight', 'bolder')
    }
  }

  return {
    setElsAlign,
    setElsSpace,
    setEleSelectByField,
    getSelectEls,
    getSelectTable,
    getAllTables,
    updateFontSize,
    updateFontWeight,
  }
}
